export const ScaleSelectRatingDisplay = ({
  rating,
  ratingsCount,
}: {
  rating: number;
  ratingsCount?: number;
}) => {
  if (!rating) {
    return null;
  }

  let display: string;

  if (rating < 1.5) {
    display = 'Poor';
  } else if (rating < 2.5) {
    display = 'Fair';
  } else if (rating < 3.5) {
    display = 'Good';
  } else if (rating >= 4.5) {
    display = 'Excellent';
  } else {
    display = 'Very Good';
  }

  return (
    <span className="leader-rating-display">
      {display} {ratingsCount ? `(${ratingsCount})` : null}
    </span>
  );
};
